import Icon from "../Icon";
import { ButtonInput, ButtonInputProps } from "./ButtonInput";

import "../../styles/inputs/ClearableInput.css";

export { ClearableInput };

type Props = {
  showClearButton?: (value: string) => boolean;
  onClear: () => void;
} & ButtonInputProps;

const ClearableInput = (props: Props) => {
  return (
    <ButtonInput {...props} className={"ClearableInput"}>
      {/* show clear button if value exists, or let prop.showClearButton determine if it's shown */}
      {props.value.length > 0 &&
        ((props.showClearButton && props.showClearButton(props.value)) ||
          !props.showClearButton) && (
          <button onClick={props.onClear}>
            <Icon altText={"Clear"} icon={"times"} />
          </button>
        )}
    </ButtonInput>
  );
};
